import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(form.email, form.password);
      if (u.role !== "admin") { toast.error("This portal is for MITRA admins only."); setLoading(false); return; }
      navigate("/admin", { replace: true });
    } catch (err) { toast.error(apiError(err)); setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0b1220] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-12 h-12 rounded-lg bg-[#003d9b] flex items-center justify-center">
            <ShieldCheck className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-white">MITRA Admin</h1>
            <p className="text-sm text-white/60">Super Admin access</p>
          </div>
        </div>
        <form onSubmit={submit} className="bg-white rounded-lg p-6 space-y-4">
          <div>
            <label className="text-sm font-semibold text-[#1c1b1b]">Email</label>
            <input data-testid="admin-email-input" type="email" required value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="mt-1 h-12 w-full rounded-lg border border-[#E5E7EB] px-4 text-[16px] focus:outline-none focus:ring-2 focus:ring-[#003d9b]" />
          </div>
          <div>
            <label className="text-sm font-semibold text-[#1c1b1b]">Password</label>
            <input data-testid="admin-password-input" type="password" required value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="mt-1 h-12 w-full rounded-lg border border-[#E5E7EB] px-4 text-[16px] focus:outline-none focus:ring-2 focus:ring-[#003d9b]" />
          </div>
          <button data-testid="admin-login-btn" disabled={loading}
            className="w-full h-12 rounded-lg bg-[#003d9b] text-white font-semibold hover:bg-[#0052cc] transition-colors disabled:opacity-50">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <button onClick={() => navigate("/login")} data-testid="nurse-portal-link" className="mt-6 text-sm text-white/60 hover:text-white transition-colors mx-auto block">
          ← Nurse Portal
        </button>
      </div>
    </div>
  );
}
